<div class="sidebar-footer">
  <div class="sidebar-footer-fields tw-flex tw-flex-column tw-gap-3">
    <!-- we use remount$ flag here as an easy way to reset any of the sub fields on assignment success -->
    <ng-container *ngIf="(remount$ | async) === false && form.get(FORM_FIELDS.SELECTED_ACTION).value as selectedAction">
      <mg-tt-hallpass-fields
        *ngIf="selectedAction.assignmentType === ASSIGNMENT_TYPE.HALLPASS"
        [form]="form"
        [type]="form.get(FORM_FIELDS.SELECTED_ACTION).value.data"></mg-tt-hallpass-fields>
      <mg-tt-consequence-fields
        class="block-assignment-input"
        *ngIf="selectedAction.assignmentType === ASSIGNMENT_TYPE.CONSEQUENCE"
        [form]="form"
        [type]="form.get(FORM_FIELDS.SELECTED_ACTION).value.data"></mg-tt-consequence-fields>
      <mg-tt-behavior-fields
        class="block-assignment-input"
        *ngIf="selectedAction.assignmentType === ASSIGNMENT_TYPE.BEHAVIOR"
        [form]="form"
        [type]="form.get(FORM_FIELDS.SELECTED_ACTION).value.data"></mg-tt-behavior-fields>
      <mg-tt-check-in-fields
        class="block-assignment-input"
        *ngIf="
          selectedAction.assignmentType === ASSIGNMENT_TYPE.CHECK_IN ||
          (selectedAction.assignmentType === ASSIGNMENT_TYPE.FLEX_TIME &&
            selectedAction.value === FLEX_ASSIGNMENT_TYPE.CHECKIN)
        "
        [form]="form"
        [type]="form.get(FORM_FIELDS.SELECTED_ACTION).value.data"></mg-tt-check-in-fields>
    </ng-container>
    <div
      *ngIf="formErrors.length > 0"
      class="tw-flex tw-flex-column tw-gap-2">
      <mg-system-alert
        class="sidebar-footer-error"
        *ngFor="let error of formErrors"
        type="error"
        [message]="error"></mg-system-alert>
    </div>
    <div class="tw-flex tw-justify-center tw-items-center md:tw-justify-end">
      <div class="tw-flex tw-flex-column tw-gap-3 assign-btn-wrap">
        <mg-btn
          class="assign-btn"
          matTooltipClass="mg-tooltip"
          [id]="
            form.get(FORM_FIELDS.SELECTED_ACTION).value?.assignmentType === ASSIGNMENT_TYPE.COMMUNICATION
              ? 'tools-myclass-click-next'
              : 'tools-myclass-click-assign-' +
                (form.get(FORM_FIELDS.SELECTED_ACTION).value?.assignmentType || 'action')
          "
          [wide]="true"
          [disabled]="LOCKED_STATES | includes: formState"
          [iconRight]="(mediaService.isMobileView$ | async) ? '' : 'mg-space'"
          [matTooltip]="getAssignLabel(form.get(FORM_FIELDS.SELECTED_ACTION).value) + ' selection (space bar)'"
          [attr.aria-label]="MESSAGES.ARIA_LABEL_ASSIGN_SELECTION"
          iconSet="minga"
          (pressed)="assign.emit()">
          {{ getAssignLabel(form.get(FORM_FIELDS.SELECTED_ACTION).value) }}
        </mg-btn>
        <ng-content select="[secondary-action]"></ng-content>
      </div>
    </div>
  </div>
</div>
